import { useSelector } from 'react-redux';
import { OfferResponse } from 'logic/api-models/api-models';
import { getCurrentYear } from 'logic/date-time/date-time';
import { getAuthenticatedUser } from 'logic/store/authentication/authentication.selectors';
import { getUserNameLabel } from 'logic/utils/user-label';
import {
  getUserRatings,
  getUserBadges,
  getOfferAverageRating,
  getOfferTotalRatings,
} from 'logic/store/rating/rating.selectors';
import getIsTutoringSchool from 'logic/helpers/isTutoringSchool';

export const useTutorInfo = ({ offer }: { offer?: OfferResponse }) => {
  const user = useSelector(getAuthenticatedUser);
  const userRatings = useSelector(getUserRatings);
  const badges = useSelector(getUserBadges);
  const averageRating = useSelector(getOfferAverageRating);
  const totalRatings = useSelector(getOfferTotalRatings);
  const isMyOffer = offer?.isMyOffer;
  const owner = isMyOffer ? user : offer?.user;
  const tutorNameLabel = getIsTutoringSchool(offer)
    ? `${offer?.tutoringSchool?.name}`
    : getUserNameLabel(owner);
  const { imageUrl: ownerImageUrl, yearOfBirth } = owner || {};
  const imageUrl = offer?.imageUrl || ownerImageUrl;
  const age = yearOfBirth ? getCurrentYear() - yearOfBirth : '';
  const city = offer?.location?.place;

  return {
    imageUrl,
    age,
    tutorNameLabel,
    averageRating,
    totalRatings,
    isMyOffer,
    userRatings,
    badges,
    city,
  };
};
